import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Divider',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "30",
    height: "32",
    viewBox: "0 0 30 32",
    fill: __props.fillColor,
    class: "mb-1.5 mt-4",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M22.9265 27.3278H7.16886C6.74327 27.3278 6.39844 26.9829 6.39844 26.5574L6.39861 19.3173C6.39861 18.8917 6.74345 18.5469 7.16903 18.5469H22.9267C23.3523 18.5469 23.6971 18.8917 23.6971 19.3173V26.5574C23.6969 26.9828 23.3521 27.3276 22.9267 27.3276L22.9265 27.3278ZM7.9392 25.7871H22.1557V20.0877H7.9392V25.7871Z",
      fill: __props.strokeColor
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M22.9265 13.8864H7.16886C6.74327 13.8864 6.39844 13.5415 6.39844 13.1159L6.39861 5.87589C6.39861 5.45031 6.74345 5.10547 7.16886 5.10547H22.9265C23.3521 5.10547 23.6969 5.45031 23.6969 5.87589V13.1159C23.6967 13.5414 23.3519 13.8862 22.9265 13.8862L22.9265 13.8864ZM7.9392 12.3457H22.1557V6.64632H7.9392V12.3457Z",
      fill: __props.strokeColor
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.7374 16.8766H22.4189C22.0551 16.8766 21.76 16.5814 21.76 16.2176C21.76 15.8537 22.0551 15.5586 22.4189 15.5586H23.7374C24.1012 15.5586 24.3963 15.8537 24.3963 16.2176C24.3963 16.5814 24.101 16.8766 23.7374 16.8766ZM19.7223 16.8766H18.4039C18.04 16.8766 17.7449 16.5814 17.7449 16.2176C17.7449 15.8537 18.04 15.5586 18.4039 15.5586H19.7223C20.0862 15.5586 20.3813 15.8537 20.3813 16.2176C20.3813 16.5814 20.0864 16.8766 19.7223 16.8766ZM15.7074 16.8766H14.3892C14.0254 16.8766 13.7303 16.5814 13.7303 16.2176C13.7303 15.8537 14.0254 15.5586 14.3892 15.5586H15.7074C16.0713 15.5586 16.3664 15.8537 16.3664 16.2176C16.3664 16.5814 16.0713 16.8766 15.7074 16.8766ZM11.6924 16.8766H10.3746C10.0107 16.8766 9.71563 16.5814 9.71563 16.2176C9.71563 15.8537 10.0107 15.5586 10.3746 15.5586H11.6928C12.0567 15.5586 12.3518 15.8537 12.3518 16.2176C12.3516 16.5815 12.0565 16.8766 11.6924 16.8766ZM7.67789 16.8766H6.35948C5.9956 16.8766 5.7005 16.5814 5.7005 16.2176C5.7005 15.8537 5.99561 15.5586 6.35948 15.5586H7.67789C8.04177 15.5586 8.33688 15.8537 8.33688 16.2176C8.33688 16.5814 8.04177 16.8766 7.67789 16.8766ZM3.663 16.8766H2.93828C2.5744 16.8766 2.2793 16.5815 2.2793 16.2176C2.2793 15.8537 2.57441 15.5586 2.93828 15.5586H3.663C4.02688 15.5586 4.32199 15.8537 4.32199 16.2176C4.32177 16.5815 4.02666 16.8766 3.663 16.8766ZM26.4337 16.8766H27.1582C27.5221 16.8766 27.8172 16.5814 27.8172 16.2176C27.8172 15.8537 27.5221 15.5586 27.1582 15.5586H26.4337C26.0699 15.5586 25.7748 15.8537 25.7748 16.2176C25.7748 16.5814 26.0699 16.8766 26.4337 16.8766Z",
      fill: __props.strokeColor
    }, null, 8, _hoisted_4)
  ], 8, _hoisted_1))
}
}

})